/**
 * The two pure decisions behind the editor's number boxes: what a typed string
 * means, and how far a slider should reach.
 *
 * Separated from the components so both can be tested as functions — "does
 * pasting `$1,200` give 1200" is a question about a string, not about React.
 */

/** Accepts what people actually paste: "1,200", "$1 200", "1200.50", "". */
export function parseNumeric(text: string): number | null {
  // The `-` sits last in the class so it is a literal, not a range.
  const cleaned = text.replace(/[^0-9.-]/g, "");
  if (cleaned === "" || cleaned === "-" || cleaned === "." || cleaned === "-.") return null;
  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
}

/**
 * A round ceiling at or above `value`, from the 1 / 2.5 / 5 / 10 ladder.
 *
 * A slider needs a maximum and a scenario has no idea what a licence costs, so
 * the range comes from the figure itself — with headroom, so there is somewhere
 * to drag *to* rather than the thumb starting pinned at the right-hand end.
 */
export function sliderCeiling(value: number, floor: number): number {
  const target = Math.max(Math.abs(value) * 1.5, floor);
  const magnitude = 10 ** Math.floor(Math.log10(Math.max(target, 1)));
  for (const step of [1, 2.5, 5, 10]) {
    const candidate = step * magnitude;
    if (candidate >= target) return candidate;
  }
  /* c8 ignore next 2 -- 10 × magnitude always clears target */
  return 10 * magnitude;
}
